import { useState } from 'react';
import Modal from 'react-modal';
import { exportXLSModalActions } from '../store/exportXLSModalSlice';
import { useExportData } from '../hooks/useExportData';
import { useDispatch, useSelector } from 'react-redux';
import { LuDownload, LuFileSpreadsheet } from "react-icons/lu";
import { FiX } from 'react-icons/fi';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '16px',
        padding: 0,
        border: 'none',
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        maxWidth: '92vw',
    },
    overlay: {
        background: 'rgba(15, 23, 42, 0.55)',
        backdropFilter: 'blur(2px)',
        zIndex: 9999,
    },
};

Modal.setAppElement(document.getElementById('root'));

export default function ExportXLS() {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.export_xls_modal.data);
    const isOpen = useSelector((state) => state.export_xls_modal.isOpen);
    const [fileName, setFileName] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { exportDataToExcel } = useExportData();

    function closeModal() {
        if (isSubmitting) return;
        setFileName('');
        dispatch(exportXLSModalActions.closeModal());
    }

    const handleDownloadClick = async () => {
        if (!fileName.trim()) {
            alert('Ju lutem shkruani emrin e dokumentit');
            return;
        }

        const params = data.params || {};
        const filters = data.filters || {};

        try {
            setIsSubmitting(true);
            await exportDataToExcel(params, fileName, filters);
            closeModal();
        } catch (error) {
            console.error('Error exporting data:', error);
            alert('Ndodhi një gabim gjatë eksportimit të të dhënave.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleDownloadClick();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Gjenero raportin"
        >
            <div className="bg-white w-[480px] max-w-full">
                <div className="flex items-start justify-between px-6 pt-5 pb-4 border-b border-gray-100">
                    <div className="flex items-center gap-3">
                        <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[var(--secondary-color)]/10 text-[var(--secondary-color)]">
                            <LuFileSpreadsheet size={20} />
                        </span>
                        <div>
                            <div className="text-base font-semibold text-gray-900">Gjenero raportin</div>
                            <div className="text-xs text-gray-500">Shkarko të dhënat në formatin Excel (.xlsx)</div>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={closeModal}
                        className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg p-1.5 transition"
                        aria-label="Mbyll"
                    >
                        <FiX size={18} />
                    </button>
                </div>

                <div className="px-6 py-5">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Emri i dokumentit
                    </label>
                    <div className="flex items-stretch rounded-xl border border-gray-300 focus-within:border-[var(--secondary-color)] focus-within:ring-1 focus-within:ring-[var(--secondary-color)]/30 transition overflow-hidden bg-white">
                        <input
                            className="flex-1 px-4 py-2.5 text-sm outline-none placeholder:text-gray-400"
                            type="text"
                            placeholder="Shkruani emrin e dokumentit..."
                            onChange={(e) => setFileName(e.target.value)}
                            onKeyDown={handleKeyDown}
                            value={fileName}
                            autoFocus
                        />
                        <span className="inline-flex items-center gap-1.5 px-3 text-xs font-semibold text-gray-500 bg-gray-50 border-l border-gray-200">
                            .xlsx
                            <LuFileSpreadsheet size={14} className="text-green-600" />
                        </span>
                    </div>
                    <p className="mt-2 text-xs text-gray-500">
                        Skedari do të shkarkohet me emrin që do të specifikoni më lart.
                    </p>
                </div>

                <div className="flex justify-end gap-2 px-6 py-4 border-t border-gray-100 bg-gray-50/60">
                    <button
                        type="button"
                        onClick={closeModal}
                        disabled={isSubmitting}
                        className="inline-flex items-center gap-2 rounded-xl border border-gray-300 bg-white hover:bg-gray-50 px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm transition disabled:opacity-50"
                    >
                        Anulo
                    </button>
                    <button
                        type="button"
                        onClick={handleDownloadClick}
                        disabled={isSubmitting || !fileName.trim()}
                        className="inline-flex items-center gap-2 rounded-xl bg-[var(--secondary-color)] hover:bg-[var(--secondary-color)]/90 active:scale-[0.98] px-4 py-2 text-sm font-semibold text-white shadow-sm transition disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                        <LuDownload size={16} />
                        {isSubmitting ? 'Duke shkarkuar...' : 'Shkarko'}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
